<template>
  <div class="newsInformation">
    <detailsTop :topIndex="topIndex" />
    <div class="news-content">
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          :bannerIndex="0"
          @changeTips="changeTips"
        />

        <div class="exhibition-item-info">
          <div class="info-title">
            <div class="info-left"></div>
            <div class="info-right">招聘简介</div>
          </div>
          <div class="info-line"></div>

          <div class="info-concent">
            暂时空着。后续填充内容
            <div v-html="newInfo.content"></div>
          </div>
        </div>
      </div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import {
  selectTPartnerPage,
  selectTNewsPage,
} from "@/api/api.js";

export default {
  name: "news",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: 6,
      bannerIndex: null,
      newInfo: {},
    };
  },
  created() {
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));

    this.$route.query.bannerIndex
      ? (this.bannerIndex = this.$route.query.bannerIndex)
      : (this.bannerIndex = 0);
    this.$route.query.topIndex
      ? (this.topIndex = this.$route.query.topIndex)
      : (this.topIndex = 6);
    this.getData();
  },
  methods: {
    //获取合作伙伴（暂未使用）
    // async getPartners() {
    //   const { data } = await selectTPartnerPage({ page: 1, size: 100 });
    //   if (data.code === 200) {
    //     this.partnersList = data.data.list;
    //   }
    // },

    async getData() {
      var params = {
        page: this.page,
        size: this.size,
        projectTypeParentId: this.bannerTipsList[this.bannerIndex]?.parentId,
        projectTypeSubId: this.bannerTipsList[this.bannerIndex]?.projectTypeId,
      };
      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
        // console.log(data.data);
        //可以获取到数据，但是数据为null
      }
    },

    changeTips(index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "contactUS",
            query: { bannerIndex: index },
          });
          break;

        case 1:
          this.$router.push({
            name: "aftersales",
            query: { bannerIndex: index },
          });

          break;
        case 2:
          this.$router.push({ name: "support", query: { bannerIndex: index } });

          break;
        case 3:
          this.$router.push({ name: "join", query: { bannerIndex: index } });
          break;
        case 4:
          this.$router.push({ name: "message", query: { bannerIndex: index } });
          break;
      }
      localStorage.setItem("bannerList", JSON.stringify(this.bannerTipsList));
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;

  .new-center {
    background: #f4f4f4;

    .exhibition-item-info {
      width: 100%;
      background: #ffffff;
      margin-top: 23px;
      text-align: left;

      .info-title {
        display: flex;
        align-items: center;
        padding-top: 25px;
        padding-left: 26px;

        .info-left {
          width: 5px;
          height: 28px;
          background: #46739f;
        }

        .info-right {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          margin-left: 16px;
        }
      }

      .info-line {
        width: 96%;
        margin: 0 auto;
        height: 1px;
        background: #eeeeee;
        margin-top: 25px;
      }

      .info-concent {
        padding-left: 26px;
        padding-right: 26px;
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        margin-top: 25px;
        background-color: pink;

        .partners-wrap {
          width: 100%;
          height: 300px;
          background: #ffffff;
          margin-bottom: 30px;
          display: flex;
          border: 1px solid #ececec;

          .partners-img {
            width: 50%;
          }

          .partners-btm {
            width: 50%;
            padding: 30px 0 0 40px;
            box-sizing: border-box;
            font-size: 14px;
            color: #333333;

            .partners-title {
              font-size: 20px;
              color: #333333;
              font-weight: 600;
            }

            .partners-info {
              width: 100%;
              height: 50px;
              line-height: 50px;
            }
          }
        }
      }
    }
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {
  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }
}
</style>
